module.exports = "pegasus/assets/blocks/column-12-theme6.png";